let lightboxRoot = null;

/** Stable portal target — avoids React removeChild conflicts on document.body. */
export function getPhotoLightboxRoot() {
  if (!lightboxRoot && typeof document !== "undefined") {
    lightboxRoot = document.createElement("div");
    lightboxRoot.id = "rs-photo-lightbox-root";
    document.body.appendChild(lightboxRoot);
  }
  return lightboxRoot;
}
